import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { rolesOf } from './roles';

// Generic route guard: pass any predicate from roles.js as `allow`.
//
//   <RoleRoute allow={canReconcile}><Reconciliation /></RoleRoute>
//
// OwnerRoute and AdminOrOwnerRoute predate this and still cover their routes.
// New role-gated routes should use this instead of adding another near-identical
// guard file — three copies of the same fetch-then-check is how the nav and the
// router drifted apart in the first place.
const RoleRoute = ({ allow, children }) => {
  const [authUser, authLoading] = useAuthState(auth);
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const checkRole = async () => {
      if (!authUser) {
        setAllowed(false);
        setChecking(false);
        return;
      }
      try {
        const snap = await getDoc(doc(db, 'users', authUser.uid));
        setAllowed(allow(rolesOf(snap.exists() ? snap.data() : null)));
      } catch (error) {
        console.error('Error checking route access:', error);
        setAllowed(false);
      } finally {
        setChecking(false);
      }
    };
    if (!authLoading) checkRole();
  }, [authUser, authLoading, allow]);

  if (authLoading || checking) {
    return (
      <div className="w-full flex justify-center items-center h-screen text-gray-500">
        Checking access...
      </div>
    );
  }

  return allowed ? children : <Navigate to="/" replace />;
};

export default RoleRoute;
